import axios from "axios";
import { toast } from "sonner";
import { API } from "@/App";

export const formatFileSize = (bytes) => {
  if (bytes < 1024) return bytes + " B";
  if (bytes < 1024 * 1024) return (bytes / 1024).toFixed(1) + " KB";
  return (bytes / (1024 * 1024)).toFixed(1) + " MB";
};

export const formatDuration = (seconds) => {
  if (!seconds) return "\u2014";
  const m = Math.floor(seconds / 60);
  const s = seconds % 60;
  return m > 0 ? `${m}m ${s}s` : `${s}s`;
};

export const toggleStudentSelection = (studentId, setter, current) => {
  setter(current.includes(studentId)
    ? current.filter(id => id !== studentId)
    : [...current, studentId]);
};

export const handleDownloadFile = async (url, filename, headers) => {
  try {
    let downloadUrl = url;
    if (url && url.includes('/api/')) {
      const apiPath = url.substring(url.indexOf('/api/') + 4);
      downloadUrl = `${API}${apiPath}`;
    }

    const response = await axios.get(downloadUrl, {
      headers,
      responseType: 'blob'
    });

    const blobUrl = window.URL.createObjectURL(new Blob([response.data]));
    const link = document.createElement('a');
    link.href = blobUrl;
    link.setAttribute('download', filename || 'download');
    document.body.appendChild(link);
    link.click();
    link.remove();
    window.URL.revokeObjectURL(blobUrl);
  } catch (error) {
    toast.error("Failed to download file. Please try again.");
  }
};

export const handleBlobDownload = async (url, filename, headers) => {
  try {
    const response = await axios.get(url, { headers, responseType: "blob" });
    const blobUrl = window.URL.createObjectURL(new Blob([response.data]));
    const link = document.createElement("a");
    link.href = blobUrl;
    link.setAttribute("download", filename);
    document.body.appendChild(link);
    link.click();
    link.remove();
    window.URL.revokeObjectURL(blobUrl);
  } catch (error) {
    toast.error("Failed to download file");
  }
};
